export const getDateNow = (): number => {
    return Date.now();
};
